/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Academy_Status_Inprogress1Inputs */

const en_academy_status_inprogress1 = /** @type {(inputs: Academy_Status_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

const ja_academy_status_inprogress1 = /** @type {(inputs: Academy_Status_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中`)
};

const fr_academy_status_inprogress1 = /** @type {(inputs: Academy_Status_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const de_academy_status_inprogress1 = /** @type {(inputs: Academy_Status_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Bearbeitung`)
};

/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Academy_Status_Inprogress1Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
const academy_status_inprogress1 = /** @type {((inputs?: Academy_Status_Inprogress1Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Academy_Status_Inprogress1Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_academy_status_inprogress1(inputs)
	if (locale === "ja") return ja_academy_status_inprogress1(inputs)
	if (locale === "fr") return fr_academy_status_inprogress1(inputs)
	return de_academy_status_inprogress1(inputs)
});
export { academy_status_inprogress1 as "academy_status_inProgress" }